import { FinancialModelSettings } from '@/feature/financial-model/api/types'

export const getCapitalStructureCompletitionStatus = (type: any, settings: FinancialModelSettings[]) => {
  const status = settings.find(setting => setting.type === type)?.status ?? `not_started`
  return status
}

export const getRemainingPeriods = (from: string, to: string) => {
  const fromDate = new Date(from)
  const toDate = new Date(to)
  const fromYear = fromDate.getFullYear()
  const fromMonth = fromDate.getMonth()
  const toYear = toDate.getFullYear()
  const toMonth = toDate.getMonth()
  const remainingPeriods = (toYear - fromYear) * 12 + (toMonth - fromMonth) + 1

  return remainingPeriods
}
